import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { prop } from 'ramda';

import { useAppSelector, useUserSelector } from '@core/js/store/hooks';

import useSendPOCTag from './useSendPOCTag';

const useUserRGInterfaceLogs = (isPageInPopup: boolean) => {
    const sendPOCTag = useSendPOCTag();
    const { pathname } = useLocation();
    const { DTAG_PAGES } = useAppSelector(prop('dynamicTags')) as Record<string, string>;
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const timeOutIdForSeconds = useRef<NodeJS.Timeout | null>(null);
    const timeOutIdForMinutes = useRef<NodeJS.Timeout | null>(null);
    const intervalId = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        if (!DTAG_PAGES?.includes(pathname) || !isLoggedIn || isPageInPopup) {
            return;
        }

        sendPOCTag(pathname);

        timeOutIdForSeconds.current = setTimeout(() => {
            sendPOCTag(pathname);
        }, 15000);

        intervalId.current = setInterval(() => sendPOCTag(pathname), 60000);

        const stopInterval = () => {
            clearInterval(intervalId.current as NodeJS.Timeout);
        };

        timeOutIdForMinutes.current = setTimeout(() => {
            stopInterval();
        }, 660000);

        return () => {
            clearTimeout(timeOutIdForSeconds.current as NodeJS.Timeout);
            clearTimeout(timeOutIdForMinutes.current as NodeJS.Timeout);
            stopInterval();
        };
    }, [DTAG_PAGES, isLoggedIn, pathname, sendPOCTag, isPageInPopup]);
};

export default useUserRGInterfaceLogs;
